import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, handleSwitchInputKeys } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

const Sync = observer(class Sync extends React.Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    this.state = {
      integrationSid: this.props.integrationSid
    }

    this.props.store.SettingsStore.getIntegration(this.props.integrationSid);
  }

  componentWillUnmount() {
    this.props.store.SettingsStore.integration = {};
  }

  handleInput(name, e, checkbox) {
    let value = e.target.value;

    if(checkbox) {
      value = e.target.checked;
    }

    const data = {
      [name]: value
    };

    this.props.store.SettingsStore.updateIntegrationData(data);
  }

  handleSubmit() {
    this.props.store.SettingsStore.updateIntegration(
      this.state.integrationSid, this.props.complete
    );
  }

  render() {
    const { translation } = this.props;
    const { SettingsStore } = this.props.store;
    const { integration } = this.props.store.SettingsStore;

    return (
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading} {integration.name}</h1>
          </div>
        </header>

        <div className="wrap block-form">
          {SettingsStore.integration.sid &&
            <form className="panel" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              <div className="panel__body">
                <fieldset className="form-section">
                  <ul className="fields">
                    <li>
                      <label htmlFor="sync-enrollments">
                        {translation.sync_enrollments}
                      </label>

                      <input
                        type="checkbox"
                        id="sync-enrollments"
                        className="switch-input"
                        defaultChecked={integration.syncEnrollments}
                        onChange={(e) => {this.handleInput('syncEnrollments', e, true)}}
                        onKeyDown={handleSwitchInputKeys}
                      />

                      <label className="switch-label" htmlFor="sync-enrollments">
                        <span className="meta">{translation.sync_enrollments}</span>
                      </label>
                    </li>

                    {integration.syncEnrollments &&
                      <li>
                        <label htmlFor="sync-enrollments-interval">
                          {translation.sync_enrollments_interval}
                        </label>

                        <label className="select">
                          <select
                            id="sync-enrollments-interval"
                            defaultValue={integration.syncEnrollmentsInterval}
                            onChange={(e) => {this.handleInput('syncEnrollmentsInterval', e)}}
                          >
                            <option value={2}>2 {translation.hours}</option>
                            <option value={3}>3 {translation.hours}</option>
                            <option value={4}>4 {translation.hours}</option>
                          </select>
                        </label>
                      </li>
                    }

                    {integration.syncEnrollments &&
                      <li>
                        <label htmlFor="sync-enrollments-expiration">
                          {translation.sync_enrollment_expiration}
                        </label>

                        <label className="select">
                          <select
                            id="sync-enrollments-expiration"
                            defaultValue={integration.syncEnrollmentsExpirationDays}
                            onChange={(e) => {this.handleInput('syncEnrollmentsExpirationDays', e)}}
                          >
                            <option value={15}>15 {translation.days}</option>
                            <option value={30}>30 {translation.days}</option>
                            <option value={45}>45 {translation.days}</option>
                            <option value={60}>60 {translation.days}</option>
                            <option value={90}>90 {translation.days}</option>
                          </select>
                        </label>
                      </li>
                    }
                  </ul>
                </fieldset>

                <div className="panel__actions actions">
                  <button
                    className="actions__btn actions__btn--primary"
                    type="submit"
                  >
                    {translation.save}
                  </button>
                </div>
              </div>
            </form>
          }
        </div>
      </div>
    )
  }
})

export default translate('Sync')(Sync);



// WEBPACK FOOTER //
// ./src/app/components/Integrations/Sync.js